/* DESTELAYR® Academia — interacciones (sin dependencias). */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('aca-js');
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  /* Header: sombra al desplazarse + menú lateral animado */
  var header = $('.aca-header'), burger = $('[data-aca-burger]'), drawer = $('#aca-drawer'), scrim = $('[data-aca-scrim]'), closeT;
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  function setDrawer(open) {
    if (!drawer || !burger) return;
    clearTimeout(closeT);
    header.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', String(open));
    doc.body.classList.toggle('aca-lock', open);
    if (open) {
      drawer.hidden = false; if (scrim) scrim.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-on'); if (scrim) scrim.classList.add('is-on'); }); });
      var first = $('a', drawer); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
    } else {
      drawer.classList.remove('is-on'); if (scrim) scrim.classList.remove('is-on');
      closeT = setTimeout(function () { drawer.hidden = true; if (scrim) scrim.hidden = true; }, reduce ? 0 : 420);
    }
  }
  if (burger && drawer) {
    burger.addEventListener('click', function () { setDrawer(!drawer.classList.contains('is-on')); });
    if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { setDrawer(false); }); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-on')) { setDrawer(false); burger.focus(); } });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1180 && drawer.classList.contains('is-on')) setDrawer(false); });
  }

  /* Pestañas (beneficios de la membresía) */
  $$('[data-aca-tabs]').forEach(function (box) {
    var tabs = $$('[role="tab"]', box), panels = $$('[data-panel]', box.parentNode);
    function select(t) {
      tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); x.tabIndex = x === t ? 0 : -1; });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== t.getAttribute('data-tab'); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (n === null) return; n = (n + tabs.length) % tabs.length; tabs[n].focus(); select(tabs[n]); e.preventDefault();
      });
    });
    select(tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0]);
  });

  /* Carruseles (scroll-snap + flechas + barra de progreso) */
  $$('[data-aca-carousel]').forEach(function (box) {
    var track = $('[data-aca-track]', box), prev = $('[data-aca-prev]', box), next = $('[data-aca-next]', box), bar = $('[data-aca-progress] i', box);
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (bar) bar.style.transform = 'scaleX(' + (max > 0 ? Math.max(.12, (track.scrollLeft + track.clientWidth) / track.scrollWidth) : 1) + ')';
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft > max - 8;
    }
    function step(dir) { var c = track.firstElementChild; var w = c ? c.getBoundingClientRect().width + 16 : 300; track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  });

  /* Pósters de los reels y del salón: se piden al acercarse, para que no compitan con el hero */
  var lazyPosters = $$('video[data-poster]');
  function givePoster(v) { var p = v.getAttribute('data-poster'); if (p) { v.setAttribute('poster', p); v.removeAttribute('data-poster'); } }
  if ('IntersectionObserver' in window && lazyPosters.length) {
    var pio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { givePoster(e.target); pio.unobserve(e.target); } }); }, { rootMargin: '700px 400px' });
    lazyPosters.forEach(function (v) { pio.observe(v); });
  } else { lazyPosters.forEach(givePoster); }

  /* Videos: se cargan tarde, reproducen solo cuando se ven y nunca varios reels a la vez */
  var videoBoxes = $$('[data-aca-video]');
  var pageReady = doc.readyState === 'complete', waiting = [];
  function load(v) {
    if (!v || v.getAttribute('src') || !v.getAttribute('data-src')) return;
    if (v.hasAttribute('data-defer') && !pageReady) { if (waiting.indexOf(v) < 0) waiting.push(v); return; }
    if (v.hasAttribute('data-hero')) v.preload = 'auto';
    v.src = v.getAttribute('data-src');
  }
  function ready() {
    if (pageReady) return; pageReady = true;
    waiting.forEach(function (v) { load(v); var box = v.closest('[data-aca-video]'); if (box && box._inView && !box._userPaused) play(box); });
    /* En móvil el hero queda debajo del texto: se deja listo en segundo plano, salvo con ahorro de datos o red lenta */
    var hv = $('video[data-hero]'), cn = navigator.connection || {};
    if (hv && !hv.getAttribute('src') && !reduce && !cn.saveData && !/(^|-)2g$|3g/.test(cn.effectiveType || '')) load(hv);
  }
  if (!pageReady) window.addEventListener('load', function () { setTimeout(ready, 300); });
  setTimeout(ready, 3500);
  function setState(box, paused) {
    var b = $('.aca-media-btn', box); if (!b) return;
    b.classList.toggle('is-paused', paused); b.setAttribute('aria-pressed', String(paused));
    b.setAttribute('aria-label', paused ? b.getAttribute('data-label-play') : b.getAttribute('data-label-pause'));
  }
  function play(box) {
    var v = $('video', box); load(v); if (!v.getAttribute('src')) return;
    var p = v.play(); setState(box, false);
    if (p && p.catch) p.catch(function () { setState(box, true); });
  }
  function pause(box) { var v = $('video', box); if (v) v.pause(); setState(box, true); }
  var fineHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  videoBoxes.forEach(function (box) {
    var v = $('video', box), btn = $('.aca-media-btn', box); if (!v) return;
    v.muted = true; v.setAttribute('playsinline', '');
    box._reel = !!box.closest('[data-aca-track]');
    box._userPaused = reduce; setState(box, true);
    if (btn) btn.addEventListener('click', function () {
      box._userPaused = !box._userPaused;
      if (box._userPaused) pause(box); else play(box);
    });
    if (box._reel && fineHover) {
      box.addEventListener('mouseenter', function () { if (!reduce) play(box); });
      box.addEventListener('mouseleave', function () { if (!box._userPaused || reduce) pause(box); });
    }
  });
  if ('IntersectionObserver' in window && videoBoxes.length) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var box = en.target; box._inView = en.intersectionRatio >= .25;
        if (box._reel && fineHover) { if (!en.isIntersecting) pause(box); return; }
        if (box._inView && !box._userPaused) play(box); else pause(box);
      });
    }, { threshold: [0, .35, .9] });
    var rio2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var box = en.target; box._inView = en.intersectionRatio > .85;
        if (box._inView && !box._userPaused) play(box); else pause(box);
      });
    }, { threshold: [0, .85, 1] });
    videoBoxes.forEach(function (b) { (b._reel && !fineHover ? rio2 : vio).observe(b); });
  }
  /* Hebras del fondo: fuera de pantalla no existen (display:none), y las del hero esperan a que el video arranque */
  var strands = $$('.aca-strands');
  function strandsSync(el) { el.classList.toggle('is-off', !!(doc.hidden || !el._vis || el._hold)); }
  strands.forEach(function (el) { el._vis = false; el._hold = !!el.closest('.aca-hero') && !reduce; });
  function releaseHold() { strands.forEach(function (el) { if (el._hold) { el._hold = false; strandsSync(el); } }); }
  var heroVideo = $('.aca-hero video');
  if (heroVideo) heroVideo.addEventListener('playing', function () { setTimeout(releaseHold, 500); }, { once: true });
  setTimeout(releaseHold, 3200);
  if ('IntersectionObserver' in window && strands.length) {
    var sio = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target._vis = e.isIntersecting; strandsSync(e.target); }); }, { threshold: 0 });
    strands.forEach(function (el) { sio.observe(el); });
  } else { strands.forEach(function (el) { el._vis = true; el._hold = false; strandsSync(el); }); }
  doc.addEventListener('visibilitychange', function () { strands.forEach(strandsSync); });

  /* Aparición suave */
  var rev = $$('.aca-reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var rio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } }); }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    rev.forEach(function (r) { rio.observe(r); });
  } else rev.forEach(function (r) { r.classList.add('is-in'); });

  /* Tarjetas de oferta: la luz sigue al cursor (solo transform; solo con mouse) */
  if (!reduce && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('.aca-offer').forEach(function (card) {
      var raf = 0, px = 0, py = 0;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect(); px = e.clientX - r.left; py = e.clientY - r.top;
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; card.style.setProperty('--mx', px + 'px'); card.style.setProperty('--my', py + 'px'); });
      }, { passive: true });
    });
  }
})();
